var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm-email"},[(_vm.showSuccess)?_c('success-validate-account',{on:{"emitCloseSuccess":_vm.emitCloseSuccess}}):_vm._e(),(_vm.showLoader)?_c('my-custom-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }